import React from "react";
import Service from "../Items/Service";

const servicesData = [
  {
    id: 1,
    name: "Responsive Design",
    content: "HTML, CSS, Bootstrap, React and JavaScript Development",
    icon: "icon-globe",
  },
  {
    id: 2,
    name: "Web Security",
    content: "Prevent websites and app from various types of attacks",
    icon: "icon-chemistry",
  },
  {
    id: 3,
    name: " Layout Aesthetics",
    content: "Improve usability, enhances accessibility to keep users engaged.",
    icon: "icon-directions",
  },
  {
    id: 4,
    name: "SEO",
    content: "Improve the website's visibility in search engine results pages and increase traffic to the site.",
    icon: "icon-rocket",
  },
  {
    id: 5,
    name: "Performance Optimization",
    content: "Improve the user experience, accessibility, search engine rankings, increase engagement rate.",
    icon: "icon-note",
  },
  {
    id: 6,
    name: "Testing and Debugging",
    content: "Ensure the proper functioning of the website using Jest and React Developer Tools",
    icon: "icon-bubbles",
  },
];

function Services() {
  return (
    <div className="row -mt-20">
      {servicesData.map((service) => (
        <div className="col-md-4 col-sm-6 mt-20" key={service.id}>
          <Service service={service} />
        </div>
        
      ))}
    </div>
  );
}

export default Services;
